import React, { createContext } from 'react';
import { useServiceForm } from '../hooks/useServiceForm'

export const ServiceFormContext = createContext(null);

export const ServiceFormContextProvider = ({ children }) => {

    const serviceFormContext = useServiceForm();

    return (
        <ServiceFormContext.Provider value={serviceFormContext}>
            {children}
        </ServiceFormContext.Provider>
    )
}
